import React, { useState } from "react";
import { Link } from "react-router-dom";

import SideMenu from "../components/SideMenu";
import "../dashscreen/DashCss.css";
import TableComp from "../components/TableComp";
function DashBoardScreen() {
  return (
    <div>
      
      <div className="row d-flex justify-content-evenly mt-4">
        <div className="col-lg-3 md-3 sm-12 dash-card">
          <h5>Revenue</h5>
          <div className="d-flex align-items-center justify-content-evenly">
            <h2>$2,112</h2>
            <span style={{ color: "red" }}>
              -11.4%<i class="fa-solid fa-arrow-down"></i>
            </span>
          </div>
          <span style={{ fontSize: "small", color: "gray" }}>
            Compared to last year
          </span>
        </div>
        <div className="col-lg-3 md-3 sm-12 dash-card">
          <h5>Sales</h5>
          <div className="d-flex align-items-center justify-content-evenly">
            <h2>$2,112</h2>
            <span style={{ color: "green" }}>
              11.4%<i class="fa-solid fa-arrow-up"></i>
            </span>
          </div>
          <span style={{ fontSize: "small", color: "gray" }}>
            Compared to last year
          </span>
        </div>
        <div className="col-lg-3 md-3 sm-12 dash-card">
          <h5>Costs</h5>
          <div className="d-flex align-items-center justify-content-evenly">
            <h2>$2,112</h2>
            <span style={{ color: "red" }}>
              -11.4%
              <i class="fa-solid fa-arrow-down"></i>
            </span>
          </div>
          <span style={{ fontSize: "small", color: "gray" }}>
            Compared to last year
          </span>
        </div>
      </div>
    </div>
  );
}

export default DashBoardScreen;
